import { commonStyles } from '../commonStyles';
export const getInputDateIntRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        ["REGULAR" /* InputDateInternalVariantType.REGULAR */]: {
            ...commonStyles(FOUNDATIONS, {
                ["FOCUSED" /* InputStateType.FOCUSED */]: {},
                ["EMPTY" /* InputStateType.EMPTY */]: {},
                ["FILLED" /* InputStateType.FILLED */]: {},
                ["ERROR_EMPTY" /* InputStateType.ERROR_EMPTY */]: {},
                ["ERROR_FILLED" /* InputStateType.ERROR_FILLED */]: {},
                ["DISABLED_EMPTY" /* InputStateType.DISABLED_EMPTY */]: {},
                ["DISABLED_FILLED" /* InputStateType.DISABLED_FILLED */]: {},
            }),
        },
    };
};
//# sourceMappingURL=regular.js.map